import { createSelector } from "reselect"
import { getDatesAdjusted as getDatesAdjustedHelper } from "helpers/dates"

export const getStartDate = (_, props) => props.startDate
export const getEndDate = (_, props) => props.endDate
export const getLatestDate = (_, props) => props.latestDate
export const getPeriod = (_, props) => props.period

export const getDatesAdjusted = createSelector(
  [getPeriod, getStartDate, getEndDate, getLatestDate],
  getDatesAdjustedHelper,
)
